<template>
    <b-modal title="Trocar de Departamento" ok-title="Mudar" cancel-title="Cancelar" centered v-model="showModal"
        size="lg" hide-footer @hidden="cancelar" content-class="lg-modal-departamento">

        <div class="lg-departamento-modal">
            <b-card class="shadow-sm mb-3" body-class="d-flex align-items-center px-3 py-3">
                <div class="lg-departamento-icon mr-3">
                    <b-icon icon="building"></b-icon>
                </div>
                <div>
                    <span class="text-muted text-uppercase small d-block">Departamento atual</span>
                    <strong>{{ currentDepartamentoNome }}</strong>
                </div>
            </b-card>

            <b-card bg-variant="light" data-manual-filter class="shadow-sm mb-3"
                body-class="px-3 px-md-4 py-3 position-relative">
                <button type="button"
                    class="btn btn-outline-primary lg-filter-toggle w-100 d-flex justify-content-between align-items-center mb-2"
                    @click="toggleFilters">
                    <span class="d-flex align-items-center">
                        <b-icon icon="funnel" font-scale="1.1" class="mr-2"></b-icon>
                        <span>Filtros</span>
                    </span>
                    <b-icon :icon="filtersOpen ? 'chevron-up' : 'chevron-down'" font-scale="1.1"></b-icon>
                </button>

                <div class="lg-filter-container" v-show="filtersOpen">
                    <b-form @submit.prevent="load">
                        <b-row class="align-items-end mx-0">
                            <b-col cols="12" md="8" class="px-0 pr-md-2">
                                <lg-form-input v-model="nome" label="Pesquisar departamentos" description=" "
                                    placeholder="Digite para filtrar" />
                            </b-col>
                            <b-col cols="12" md="4" class="px-0 mt-3 mt-md-0 d-flex justify-content-md-end">
                                <b-button id="buscar-departamento" class="mr-2" type="submit" size="sm" pill
                                    variant="primary">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" />
                                    </div>
                                    <b-tooltip target="buscar-departamento" title="Buscar"></b-tooltip>
                                </b-button>
                                <b-button id="limpar-departamento" size="sm" pill variant="outline-secondary"
                                    @click="clearFilters" :disabled="!nome">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" />
                                    </div>
                                    <b-tooltip target="limpar-departamento" title="Limpar filtro"></b-tooltip>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </b-card>

            <b-card class="shadow-sm" body-class="px-0">
                <div class="px-3 pt-3 pb-2 d-flex flex-wrap justify-content-between align-items-center">
                    <div class="text-muted small mb-2 mb-md-0">
                        <span v-if="total > 0">Página {{ page }} de {{ totalPage }} — {{ total }}
                            departamentos</span>
                        <span v-else>Nenhum departamento encontrado</span>
                    </div>
                    <b-badge variant="light" class="text-primary font-weight-normal">
                        Clique duas vezes para confirmar a troca
                    </b-badge>
                </div>

                <b-table responsive small hover :busy="busy" :items="records" :fields="tableFields"
                    class="mb-0" show-empty @row-dblclicked="setSelected" @row-clicked="previewDepartamento"
                    :tbody-tr-class="rowClass">
                    <template #empty>
                        <div class="text-center py-4 text-muted">
                            Nenhum departamento encontrado com o filtro aplicado
                        </div>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-4">
                            <b-spinner class="align-middle mr-2"></b-spinner>
                            <strong>Carregando departamentos...</strong>
                        </div>
                    </template>

                    <template #cell(nome)="{ item }">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <span>{{ item.nome }}</span>
                            <b-badge v-if="isCurrentDepartamento(item)" variant="primary" pill>Atual</b-badge>
                        </div>
                    </template>
                </b-table>

                <div class="px-3 pb-3 pt-2 border-top">
                    <b-row class="align-items-center">
                        <b-col cols="12" md="6" class="text-muted small mb-2 mb-md-0">
                            Exibindo {{ records.length }} de {{ total }} registros
                        </b-col>
                        <b-col cols="12" md="6" class="d-flex justify-content-md-end align-items-center">
                            <span class="mr-2 text-muted small">Mostrar</span>
                            <b-form-select size="sm" v-model="perPage" class="w-auto mr-3"
                                @change="() => this.load()" :options="perPageOptions"></b-form-select>
                            <b-pagination size="sm" v-model="page" :per-page="perPage" :total-rows="total"
                                align="right" class="mb-0"></b-pagination>
                        </b-col>
                    </b-row>
                </div>
            </b-card>

            <div class="lg-modal-actions d-flex flex-wrap justify-content-between align-items-center mt-3 pt-2 border-top">
                <b-button id="cancelar-mudar-departamento" class="my-2 btn-cancel" size="sm" variant="link"
                    @click="cancelar">
                    <b-icon icon="arrow-left" class="mr-1" />
                    Voltar para o atual
                </b-button>
                <b-button id="confirmar-mudar-departamento" class="my-2" size="sm" pill variant="primary"
                    :disabled="!pendingSelection || busy" @click="confirmarTroca">
                    <b-icon icon="arrow-right-circle" class="mr-1" />
                    {{ trocarButtonLabel }}
                </b-button>
            </div>
        </div>

    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { setDepartamento, getUsuario, getDepartamento, setPermissoes,setModulos } from "@/core/auth";
import UsuarioService from "@/core/api/UsuarioService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"

export default {
    components: { LgFormInput },
    data() {
        return {
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            page: 1,
            total: 0,
            totalPage: 0,
            records: [],
            busy: false,
            showModal: false,
            selected: null,
            nome: '',
            filtro: {},
            filtersOpen: true,
            pendingSelection: null,
            currentDepartamento: null,
        };
    },
    mixins: [ListResourceMixin],

    watch: {
        page() {
            this.load()
        }
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "nome",
                    label: "Nome",
                },

            ]
        },
        currentDepartamentoNome() {
            if (this.currentDepartamento) {
                if (this.currentDepartamento.nome) {
                    return this.currentDepartamento.nome;
                }
                if (this.currentDepartamento.descricao) {
                    return this.currentDepartamento.descricao;
                }
            }
            return "Não identificado";
        },
        pendingSelectionNome() {
            if (this.pendingSelection) {
                if (this.pendingSelection.nome) {
                    return this.pendingSelection.nome;
                }
                if (this.pendingSelection.descricao) {
                    return this.pendingSelection.descricao;
                }
            }
            return "";
        },
        trocarButtonLabel() {
            if (this.pendingSelectionNome) {
                return `Trocar para ${this.pendingSelectionNome}`;
            }
            return "Trocar";
        },
    },
    beforeMount() {

        const idUser = getUsuario().id;

        this.$service = new ResourceService(
            `/api/sgu/usuarios/${idUser}/departamentos`
        );
        this.$usuarioService = new UsuarioService();
        const departamentoAtual = getDepartamento();
        if (departamentoAtual) {
            this.currentDepartamento = departamentoAtual;
            this.selected = { id: departamentoAtual.setorId, nome: departamentoAtual.nome };
        }
        this.load();

    },

    methods: {
        show() {
            this.showModal = true;
        },
        cancelar() {
            this.showModal = false;
            this.pendingSelection = null;
        },

        toggleFilters() {
            this.filtersOpen = !this.filtersOpen
        },

        clearFilters() {
            if (!this.nome) {
                return;
            }
            this.nome = '';
            this.page = 1;
            this.load();
        },

        async load() {
            this.filtro = {}

            if (this.nome && this.nome != "") {
                this.filtro.filter = this.nome
            }


            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            })

            if (this.pendingSelection && !this.records.some(item => item.id === this.pendingSelection.id)) {
                this.pendingSelection = null;
            }
        },
        previewDepartamento(item) {
            if (!item || this.isCurrentDepartamento(item)) {
                this.pendingSelection = null;
                return;
            }
            this.pendingSelection = item;
        },

        rowClass(item) {
            if (!item) {
                return '';
            }
            if (this.isCurrentDepartamento(item)) {
                return 'row-current';
            }
            if (this.pendingSelection && this.pendingSelection.id === item.id) {
                return 'row-pending';
            }
            return '';
        },

        isCurrentDepartamento(item) {
            if (!this.currentDepartamento || !item) {
                return false;
            }
            const currentId = this.currentDepartamento.setorId || this.currentDepartamento.id;
            return item.id === currentId;
        },

        confirmarTroca() {
            if (!this.pendingSelection || this.busy) {
                return;
            }
            this.setSelected(this.pendingSelection);
        },

        setContext(obj) {
            const context = localStorage.getItem("context");
            const newContext = context ? { ...JSON.parse(context), ...obj } : obj;
            localStorage.setItem("context", JSON.stringify(newContext));
        },

        async setSelected(departamento) {
            this.busy = true;
            this.pendingSelection = departamento;
            this.selected = departamento;
            this.$usuarioService
                .mudarDepartamentoUsuario(getUsuario().id, this.selected.id)
                .then(response => {

                    response.data.usuario.privilegios = response.data.permissoes;
                    response.data.usuario.modulos = response.data.modulos;
                    setModulos(response.data.modulos);
                    setPermissoes(response.data.permissoes);
                    this.setContext({ usuario: response.data.usuario });

                    setDepartamento(response.data.departamento);
                    this.$store.commit("setDepartamento", response.data.departamento);
                    this.setContext({ departamento: response.data.departamento });
                    location.reload();


                });
        },
    },
};
</script>

<style scoped>
.lg-modal-departamento {
    border-radius: 12px;
    overflow: hidden;
}

.lg-departamento-modal {
    padding: 4px 4px 12px;
}

.lg-departamento-icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background: rgba(13, 110, 253, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0d6efd;
    font-size: 1.25rem;
}

.row-current td {
    background-color: rgba(13, 110, 253, 0.08) !important;
    font-weight: 600;
}

.row-pending td {
    background-color: rgba(13, 110, 253, 0.04) !important;
}

.row-current td:first-child,
.row-pending td:first-child {
    border-left: 3px solid #0d6efd;
}

.row-current td,
.row-pending td {
    transition: background-color 0.2s ease;
}

.lg-departamento-modal .border-top {
    border-color: rgba(0, 0, 0, 0.06) !important;
}

.lg-departamento-modal .btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}

.lg-modal-actions {
    gap: 12px;
}

.btn-cancel {
    color: #6c757d !important;
    font-weight: 500;
}

.btn-cancel:hover {
    color: #495057 !important;
    text-decoration: none;
}

@media (max-width: 767.98px) {
    .lg-departamento-modal {
        padding: 0;
    }
}
</style>
